/**
 * Filtros y Sort sticky en mobile.
 */
(function () {
  var mq = window.matchMedia('(max-width: 767px)');
  var pending = false;

  function sync() {
    var bar = document.querySelector('#gf-controls-container');
    var header = document.querySelector('.main-header-wrapper');
    if (!bar || !header) return;

    var sticky = mq.matches && bar.classList.contains('fixed');
    document.body.classList.toggle('ab-filtros-sticky', sticky);
    bar.style.top = sticky ? Math.round(header.getBoundingClientRect().height) + 'px' : '';
  }

  function onScroll() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; sync(); });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('DOMContentLoaded', sync);
  sync();
})();
